import React from 'react';
import PanelGroup from '@dealroadshow/uikit/core/components/PanelGroup';
import data from './FaqData';
import FaqItem from './FaqItem';

import styles from '../styles.scss';

const FaqPanel = () => (
  <div className={ styles.pricingPanelContainer }>
    <div className={ styles.pricingHeader }>
      <div className={ styles.pricingHeaderTitle }>
        Frequently Asked Questions
      </div>
    </div>

    <PanelGroup
      dataTest="priceFaqGroup"
      className={ styles.faqPanelGroup }
    >
      {
        data.map((item) => <FaqItem key={ item.hash } { ...item } />)
      }
    </PanelGroup>
  </div>
);

export default FaqPanel;
